// extracted by mini-css-extract-plugin
module.exports = {"container":"AjudaRapida_container__3u2-T","iconeAjudaRapida":"AjudaRapida_iconeAjudaRapida__gYxwK"};